export const SHARED_ACCESS = {
    HEADING: "Shared Access",
    SUB_HEADING: "To update access to your envelopes and your access to the envelopes of other.",
    SHARED_WITH_OTHERS: "SHARED WITH OTHERS",
    SHARED_WITH_ME:  (name: string) => name ? `SHARED WITH ${name}` : `SHARED WITH ME`,
    SHARE_ACCESS_WITH_OTHERS: "Share Access With Others",
    AVAILABLE_USERS: 'Available Users',
    SELECTED: 'Selected',
    DELEGATE: "Delegate",
    NAME: "Name",
    EMAIL: 'Email',
    SHARED_ENVELOPE_ACCESS: 'Shared Envelopes Access',
    YES:'Yes',
    NO: 'No',
    CANCEL: 'Cancel',
    PERMISSION: 'Permission',
    START_DATE: "Start Date",
    END_DATE: "End Date",
    REMOVE: 'Remove',
    STATUS: "Status",
    USER_REQUIRED: 'Please select atleast one user.',
    PERMISSION_FIELD: {
        REQUIRED: 'Permission is required',
        TEXT: '1. Select Permissions',
        OPTION_1: 'Allow to manage on behalf of you',
        OPTION_1_PLACEHOLDER: 'Includes the ability to view envelopes, view history, download files.',
        OPTION_2: 'Allow to edit on behalf of you',
        OPTION_2_PLACEHOLDER: "Includes the ability to resend, and correct in addition to what's available when managing on the user's behalf.",
        OPTION_3: 'Allow to send on behalf of you',
        OPTION_3_PLACEHOLDER: "Includes the ability to create and send envelopes in addition to what's available when editing on the user's behalf.",
    },
    DURATION_FIELD: '2. Set Duration',
    USERS_FIELD: '3. Select Users',
    USERS_SUB_TEXT: 'Users that already have access cannot be selected. Please remove their access before granting then new access.',
    ADD_ACCESS_SAVE_BUTTON_TEXT: "Save",
    STATUS_TYPES: {
        ACTIVE: "Active",
        INACTIVE: "Inactive",
        SCHEDULED: "Scheduled"
    },
    SIGNER_MESSAGE: "You're signing on behalf of",
    DELEGATION_ADDED_SUCCESSFULLY: "Delegation added successfully",
    DELETE_SUCCESSFULLY: 'Shared access has been removed successfully.'
}